import axios from "axios"
import { call } from "redux-saga/effects"

export function* rpc(
    url,
    token,
    action,
    runNow,
    payload,
    file
) {
    console.log("Pulling", action)
    // console.log(url, token)
    // console.log(action, runNow)
    // console.log(payload)
    // console.log(file)

    var formData = new FormData()
    
    var formToSend = {
        action: action,
        runNow: runNow,
        payload: payload
    }

    formData.append("file", file)
    formData.append("data",
        new Blob([JSON.stringify(formToSend)], {
            type: "application/json"
        }))


    var r = yield call(() => axios.post(url + "/rpc", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
    }).then(response => response)
        .catch(error => error))

    return r;
}